module.exports = require('./lib');
module.exports.connect = require('react-redux').connect;



//////////////////
// WEBPACK FOOTER
// ./~/_dva@2.4.0@dva/index.js
// module id = 57
// module chunks = 6